import { Component, input, Input, OnInit } from '@angular/core';
import {NgxFloatUiPlacements, NgxFloatUiTriggers} from 'ngx-float-ui';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements OnInit {

  title = input<string>();
  paragraphs = input<string[]>([]);
  position = input<'left' | 'right'>('right');

  constructor() { }

  ngOnInit(): void {
  }

  protected readonly NgxFloatUiTriggers = NgxFloatUiTriggers;
  protected readonly NgxFloatUiPlacements = NgxFloatUiPlacements;
}
